import { BusinessItem } from '@ntap/core';
import { TreeNode } from 'primeng/api';

export class TreeBusinessItem extends BusinessItem {
  $parentNode: TreeNode;
}

export type EarhivTreeNode = {
  id?: any;
  lockedIconClass?: string;
  children?: EarhivTreeNode[];
  parent?: TreeNode & EarhivTreeNode;
  offset?: number;
} & TreeNode;
